export const menuList = [
  {
    title: "Dashboard",
    icon: "ri-dashboard-fill",
    route: "dashboard",
  },
  {
    title: "Assigned Schools",
    icon: "bx bxs-book-open",
    route: "assignments",
    access: ['y67107'],

  },
  {
    title: "Manage School(s)",
    icon: "bx bx-building-house",
    route: "schoolsList",
    access: ["y43975"],
  },
  {
    title: "Manage Examiner(s)",
    icon: "ri-group-line",
    // route: "examiners",
    route: "menu",
    id: 'yi89-90uy9-290de',
    access: ["y48691", "y32170"],
    children: [
      {
        title: "Examiner(s)",
        icon: "ri-group-line",
        route: "examiners",
        acc: "y48691",
      },
      {
        title: "New",
        icon: "ri-user-add-line",
        route: "new-examiners",
        acc: "y32170",
      }
    ]

  },

];
